import { changeTariffFromBackend } from '@entities/tariff/lib';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const createChild = async (data: { name: string; currency: number }) => {
    // @ts-ignore
    const url = routable.getRoute('estimateAddChild');
    try {
        const response = await $api.post(url, data);
        console.log('response', response);
        window.location.href = response.data.redirect_url;
    } catch (error) {
        if (error?.response?.data.status === 'tariff-error') {
            await changeTariffFromBackend(error?.response?.data.tariff_popup_url);
        } else {
            handleAxiosFetchErrorsSwal(error?.response?.data);
        }
        return error;
    }
};
